export default __webpack_public_path__ + "static/media/problems.7bd1370e.svg";